PJQ.models.projects = {};
PJQ.collections.projects = {};
PJQ.views.projects = {};

//Models
PJQ.models.projects.Project = PJQ.models.BaseModel.extend({
    options: {
        isDetail: false
    },
    idAttribute: "projectId",
    notifyName: 'Project',
    endpoint: function (isBase) {
        if (this.options.isDetail && !isBase) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                }
            ], [
                {
                    parameter: 'isDetail',
                    value: this.options.isDetail
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                }
            ]);
        }
    },
    beforeInit: function (options) {
        if (this.preferences == null) {
            this.preferences = new PJQ.models.preferences.Preferences();
        }
    },
    fetchPermissions: function (callback) {
        if (this.permissions != null) {
            callback(this.permissions);
            return;
        }

        this.permissions = new PJQ.models.permissions.ProjectPermissions({
            projectId: PJQ.app.session.project ? PJQ.app.session.project.id : this.id
        });
        this.permissions.fetch({
            success: _.bind(function () {
                callback(this.permissions);
            }, this)
        });
    },
    fetch: function (options) {
        PJQ.models.BaseModel.prototype.fetch.call(this, _.defaults({
            success: (model, response) => {
                this.fetchPermissions((perm) => {
                    if (perm && perm.get('contactId') > 0
                        && (PJQ.app.session.contact == null || PJQ.app.session.contact.id !== perm.get('contactId'))) {
                        PJQ.app.session.contact = new PJQ.models.contacts.Contact({
                            id: perm.get('contactId'),
                            contactId: perm.get('contactId')
                        });
                    }

                    if (options && typeof options.success === 'function') {
                        options.success(model, response);
                    }
                });
            },
            error: options && typeof options.error === 'function' ? options.error : null
        }, options));
    },
    parse: function (model) {
        if (model) {
            if (model.preferences) {
                if (this.preferences && model.preferences) {
                    this.preferences.set(model.preferences);
                    this.preferences.parse(model.preferences);
                } else if (model.preferences) {
                    if (model.preferences instanceof PJQ.models.preferences.Preferences)
                        this.preferences = model.preferences;
                    else
                        this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
                }
            }

            this.subscription = new PJQ.models.subscriptions.Subscription(model.subscription);

            if (model.nda) {
                this.nda = new PJQ.models.projects.ProjectNDA(_.extend({project: this}, model.nda));
            } else {
                this.nda = null;
            }

            if (model.user) {
                this.user = new PJQ.models.projectContacts.ProjectContact(model.user);
            } else {
                this.user = null;
            }

            if (model.user2) {
                this.user2 = new PJQ.models.projectContacts.ProjectContact(model.user2);
            } else {
                this.user2 = null;
            }

            if (model.orderSettings) {
                this.orderSettings = new PJQ.models.BaseModel(model.orderSettings)
            } else {
                this.orderSettings = null;
            }

            if (model.participants) {
                if (model.participants instanceof PJQ.collections.projectParticipants.ProjectParticipants) {
                    this.participants = model.participants;
                    this.participants.options.project = this;
                } else {
                    this.participants = new PJQ.collections.projectParticipants.ProjectParticipants(model.participants, {
                        project: this
                    });
                }
            } else {
                this.participants = new PJQ.collections.projectParticipants.ProjectParticipants(null, {
                    project: this
                });
            }

            if (model.projectContacts) {
                if (model.projectContacts instanceof PJQ.collections.projectContacts.ProjectContacts) {
                    this.projectContacts = model.projectContacts;
                    this.projectContacts.options.project = this;
                } else {
                    //Temporary, the API is currently returning a list of ids for the apps
                    if (_.size(model.projectContacts) > 0 && typeof model.projectContacts[0] === 'number') {
                        model.projectContacts = [];
                    }
                    this.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(model.projectContacts, {
                        project: this
                    });
                }
            } else {
                this.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                    project: this
                });
            }
        }
        return model;
    },
    hasPermission: function (permission, options = {}) {
        return this.permissions == null || this.permissions.hasPermission(permission, options);
    },
    checkDownloadRequirements: function (callback) {
        callback = typeof callback === 'function' ? callback : _.noop;
        if (this.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
            if (PJQ.app.session.contact != null && this.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_CONTACT_UPDATE_REQ) === true && PJQ.app.session.contact.get('updatedOn') == null) {
                new PJQ.views.contacts.BaseEditContactModal({
                    alert: "You must update your contact information before downloading.",
                    onSave: _.bind(function () {
                        PJQ.app.session.contact.set('updatedOn', new Date());
                        this.checkDownloadRequirements(callback);
                    }, this),
                    model: new PJQ.models.projectContacts.ProjectContact({
                        id: PJQ.app.session.contact.id,
                        projectId: this.id
                    })
                });
                return;
            }

            if (PJQ.app.session.contact != null && (this.messageResponses != null && _.size(_.filter(this.messageResponses.messages.models, function(message) { return message.get('isResponseRequired') === true; })) > 0) && this.preferences.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_RESPONSE_REQ) && (_.size(this.get('bidResponse')) === 0 || (this.get('bidResponse') === ("PENDING" || "UNSENT")))) {
                this.fetchProjectMessageResponses(_.bind(function (messages) {
                    let contextMessage = messages.getContextMessage();
                    if (contextMessage != null) {
                        new PJQ.views.BaseModal({
                            header: "Bid Response Required",
                            body: "You must update your bid response before downloading.",
                            isShowCancelButton: false
                        });

                        /*
                        new PJQ.views.projects.ProjectMessageResponseModal({
                            model: contextMessage,
                            alert: 'You must update your bid response before downloading.',
                            project: this,
                            onResponse: _.bind(function (response) {
                                this.set('bidResponse', response);
                                this.checkDownloadRequirements(callback);
                            }, this)
                        });
                         */
                    } else {
                        this.checkDownloadRequirements(callback);
                    }
                }, this));
                return;
            }

            if (_.size(this.get('downloadTerms')) > 0 && !this.get('downloadTermsAgreed')) {
                new PJQ.views.projects.DownloadTermsModal({
                    project: this,
                    onAccept: _.bind(function () {
                        this.checkDownloadRequirements(callback);
                    }, this)
                });
            } else {
                callback();
            }
        } else {
            callback();
        }
    },
    clone: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'clone'
                }
            ])
        }).post().done(_.bind(function (response) {
            callback(new PJQ.models.projects.Project(response));
        }, this));
    },
    copy: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (response) {
            callback(new PJQ.models.projects.Project(response));
        }, this));
    },
    addParticipantsById: function (ids, callback) {
        new PJQ.ajax.Request({
            endpoint: '/projects/' + PJQ.app.session.project.id.toString() + '/participants/ids',
            data: {
                ids: _.map(ids, function (contact) {
                    return contact.id;
                })
            }
        }).post().success(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: _.size(ids) + ' participants added successfully'
            });
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(_.bind(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    addParticipants: function (groups, zip, radius, locationType, canCrossStateBoundaries, directoryFilter, isUnion, isNonUnion, isPrevailingWage, isNoLaborStatus, isReturnContactIds, success, error) {
        let groupIds = [];
        if (_.size(groups) > 0) {
            if (groups[0].id) {
                groupIds = _.map(groups, function (group) {
                    return group.id;
                });
            } else {
                groupIds = _.uniq(groups);
            }
        }

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'participants'
            },
            {
                endpoint: 'simple'
            }
        ]);
        let request = new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                projectId: this.id,
                groupIds: groupIds,
                zip: zip,
                radius: radius,
                locationType: locationType,
                canCrossStateBoundaries: canCrossStateBoundaries,
                directoryFilter: directoryFilter,
                isUnion: isUnion,
                isNonUnion: isNonUnion,
                isPrevailingWage: isPrevailingWage,
                isNoLaborStatus: isNoLaborStatus,
                isReturnContactIds: isReturnContactIds
            }
        });
        request.post().done(_.bind(function (data) {
            success(data);
        }, this)).fail(function () {
            error();
        });
    },
    getCompanyLogoUrl: function (callback) {
        if (this.get('logoUrl') != null) {
            callback(this.get('logoUrl'));
        }

        if (this.get('masterUserId') > 0) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'users',
                        value: this.get('masterUserId')
                    },
                    {
                        endpoint: 'logo'
                    }
                ])
            }).get().done(_.bind(function (response) {
                this.set('logoUrl', response.url);
                callback(response.url);
            }, this));
        } else {
            callback(null);
        }
    },
    updateResponse: function (response, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'respond',
                    value: response
                }
            ])
        }).put().done(_.bind(function () {
            callback();
        }, this));
    },
    fetchGroups: function (callback, forCompany = false) {
        return new Promise((resolve, reject) => {
            if (forCompany) {
                if (this.companyGroups != null) {
                    if (typeof callback === 'function') {
                        callback(this.companyGroups);
                    }
                    resolve(this.companyGroups);
                    return;
                }

                PJQ.app.session.fetchUserGroups(this.get('masterUserId'), (groups) => {
                    if (groups == null) {
                        if (typeof callback === 'function') {
                            callback(null);
                        }
                        reject(null);
                        return;
                    }

                    this.companyGroups = groups;
                    if (typeof callback === 'function') {
                        callback(groups);
                    }
                    resolve(groups);
                });
                return;
            }

            if (this.groups == null) {
                this.groups = new PJQ.collections.groups.Groups(null, {
                    project: this
                });
            }

            if (!this.groups.isFetched) {
                this.groups.fetch({
                    success: _.bind(function () {
                        callback(this.groups);
                    }, this)
                });
            } else {
                callback(this.groups);
            }
        });
    },
    fetchBidPackages: function (callback) {
        if (this.bidPackages == null) {
            this.bidPackages = new PJQ.collections.bidPackages.BidPackages(null, {
                projectId: this.id
            })
        }

        if (!this.bidPackages.isFetched) {
            this.bidPackages.fetch({
                success: _.bind(function () {
                    callback(this.bidPackages);
                }, this)
            });
        } else {
            callback(this.bidPackages);
        }
    },
    fetchERPObject: function (callback) {
        return new Promise((resolve, reject) => {
            let exObj = this.get('externalObject');
            if (exObj != null || this.erpObjectFetched) {
                if (typeof callback === 'function') {
                    callback(exObj);
                }
                resolve(exObj);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.id
                    },
                    {
                        endpoint: 'erpobject'
                    }
                ]),
                isAPIv2: true
            }).get().done((data) => {
                if (data != null) {
                    this.set({
                        externalObject: data
                    }, {
                        silent: true
                    });
                }
                this.erpObjectFetched = true;
                if (typeof callback === 'function') {
                    callback(data);
                }
                resolve(data);
            }).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(null);
            });
        });
    },
    linkERP: function (externalId, callback) {
        if (_.size(externalId) === 0) {
            callback(null);
            return;
        }

        new PJQ.ajax.Request({
            endpoint: this.endpoint(true) + '/linkerp?externalId=' + externalId,
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                if (res && _.size(res.externalId) > 0) {
                    this.set('externalObject', res);
                }
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    fetchVersions: function (callback) {
        if (this.versions == null) {
            this.versions = new PJQ.collections.drawings.Versions(null, {
                project: this
            });
        }
        if (!this.versions.isFetched) {
            this.versions.fetch({
                success: _.bind(function () {
                    callback(this.versions);
                }, this)
            });
        } else {
            callback(this.versions);
        }
    },
    fetchAttachments: function (options, callback) {
        let att;
        if (options && options.isPrivate === false) {
            if (this.sharedAttachments == null) {
                this.sharedAttachments = new PJQ.collections.projects.ProjectAttachments(null, {
                    project: this,
                    isPrivate: false,
                    isShared: true
                });
            }
            att = this.sharedAttachments;
        } else if (options && options.isShared === false) {
            if (this.privateAttachments == null) {
                this.privateAttachments = new PJQ.collections.projects.ProjectAttachments(null, {
                    project: this,
                    isShared: false,
                    isPrivate: true
                });
            }
            att = this.privateAttachments;
        } else {
            if (this.attachments == null) {
                this.attachments = new PJQ.collections.projects.ProjectAttachments(null, {
                    project: this
                });
            }
            att = this.attachments;
        }

        let fnResult = _.bind(function () {
            let resultAtt = [];
            _.each(att.models, function (attachment) {
                resultAtt.push(attachment.clone());
            });
            let result = new PJQ.collections.projects.ProjectAttachments(resultAtt, {
                project: this,
                isShared: att.options.isShared,
                isPrivate: att.options.isPrivate,
                isDeferred: att.options.isDeferred
            });
            result.isFetched = true;
            if ((!options || options.includeDrawings !== false) && !this.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DRAWINGS)) {
                if (PJQ.app.session.project.permissions == null || PJQ.app.session.project.permissions.hasPermission('drawings.canView')) {
                    this.fetchVersions(_.bind(function (versions) {
                        callback(versions.createPsuedoFolders(result));
                    }, this));
                } else {
                    callback(result);
                }
            } else {
                callback(result);
            }
        }, this);

        if (options && options.forceRecursive) {
            att.options.isDeferred = false;
            att.fetch({
                success: function () {
                    fnResult();
                }
            });
        } else {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.id
                    },
                    {
                        endpoint: 'attachmentscount'
                    }
                ])
            }).get().done(_.bind(function (data) {
                att.options.isDeferred = data.total > 1500;
                att.fetch({
                    success: function () {
                        fnResult();
                    }
                });
            }, this)).fail(function () {
                //error();
            });
        }
    },
    downloadAttachments: function (attachments, options) {
        let ids = [],
            entryIds = [],
            hasPrivate = false,
            hasNonPrivate = false,
            objType = PJQ.helpers.objectHelpers.refinedType(attachments, true),
            fnCheck = function (att) {
                if (att.get('entryId') === -1) {
                    hasNonPrivate = true;

                    ids.push(..._.map(att.getFolderAttachments(), function (folderAtt) {
                        return folderAtt.id;
                    }));

                    _.each(att.getFolderAttachments(), function (folderAtt) {
                        if (!folderAtt.get('isFolder')) {
                            entryIds.push(folderAtt.get('isDrawing') ? folderAtt.get('drawingId') * -1 : folderAtt.get('entryId'));
                        }
                    });
                } else {
                    ids.push(att.id);

                    if (!att.get('isFolder')) {
                        entryIds.push(att.get('isDrawing') ? att.get('drawingId') * -1 : att.get('entryId'));
                    }

                    if (!hasNonPrivate) {
                        let parents = att.getParentFolder(true);
                        if (parents.length === 0) {
                            if (att.get('name') !== 'Private')
                                hasNonPrivate = true;
                        } else if (parents[parents.length - 1].get('name') !== 'Private') {
                            hasNonPrivate = true;
                        }
                    }
                }
            };
        if (objType === 'backboneCollection') {
            _.each(attachments.models, function (attachment) {
                fnCheck(attachment);
            });
        } else if (objType === 'array') {
            _.each(attachments, function (attachment) {
                fnCheck(attachment);
            })
        } else {
            fnCheck(attachments);
        }

        if (this.orderSettings != null &&
            this.orderSettings.get('downloadPerFileFee') > 0 &&
            (this.get('masterUserId') !== PJQ.app.session.get('masterUserId') || (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS) && hasNonPrivate)) && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {

            if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.files.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    files: attachments,
                    orderSettings: this.orderSettings,
                    project: PJQ.app.session.project != null ? PJQ.app.session.project : options.project
                });
            }
            return;
        }

        let hasDrawings = _.find(ids, function (id) {
            return id < -1;
        }) != null;
        if (hasDrawings) {
            PJQ.files.downloadDrawings(attachments, this, options);
        } else {
            PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'attachments'
                }
            ]), {entryList: ids});
        }
    },
    attachFiles: function (files, callback) {
        if (PJQ.helpers.objectHelpers.refinedType(files) === 'object') {
            files = [files];
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'attachments'
                },
                {
                    endpoint: 'attach'
                }
            ], [
                {
                    parameter: 'entryList',
                    value: _.map(files, function (file) {
                        return file.get('entryId');
                    }).join(',')
                }
            ]),
            data: { cloudFlareFix: true }
        }).put().done(function () {
            callback(true);
        }).fail(function () {
            callback(false);
        });
    },
    detachFiles: function (files, callback) {
        if (PJQ.helpers.objectHelpers.refinedType(files) === 'object') {
            files = [files];
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'attachments'
                },
                {
                    endpoint: 'detach'
                }
            ], [
                {
                    parameter: 'entryList',
                    value: _.map(files, function (file) {
                        return file.get('entryId');
                    }).join(',')
                }
            ])
        }).delete().done(_.bind(function () {
            callback(true);
        }, this)).fail(_.bind(function () {
            callback(false);
        }, this));
    },
    fetchProjectMessageResponses: function (callback) {
        if (this.messageResponses == null) {
            this.messageResponses = new PJQ.models.projectMessages.ProjectMessagesResponse({
                projectId: this.id
            });
        }

        if (!this.messageResponses.isFetched) {
            this.messageResponses.fetch({
                success: _.bind(function () {
                    callback(this.messageResponses);
                }, this)
            });
        } else {
            callback(this.messageResponses);
        }
    },
    fetchParticipants: function (callback) {
        if (this.participants == null) {
            this.participants = new PJQ.collections.projectParticipants.ProjectParticipants(null, {
                project: this
            });
        }

        if (!this.participants.isFetched) {
            this.participants.fetch({
                success: _.bind(function () {
                    callback(this.participants);
                }, this)
            });
        } else {
            callback(this.participants);
        }
    },
    fetchProjectContacts: function (callback) {
        if (this.projectContacts == null) {
            this.projectContacts = new PJQ.collections.projectContacts.ProjectContacts(null, {
                project: this
            });
        }

        if (!this.projectContacts.isFetched) {
            this.projectContacts.fetch({
                success: _.bind(function () {
                    callback(this.projectContacts);
                }, this)
            });
        } else {
            callback(this.projectContacts);
        }
    },
    fetchDailyReportSettings: function (callback) {
        this.dailyReportSettings = new PJQ.models.dailyReports.Settings({
            project: this
        });
        this.dailyReportSettings.fetch({
            success: _.bind(function () {
                callback(this.dailyReportSettings);
            }, this)
        });
    },
    fetchBidFormSettings: function (callback) {
        this.bidFormSettings = new PJQ.models.bidForms.Settings({
            projectId: this.id
        });
        this.bidFormSettings.fetch({
            success: _.bind(function () {
                callback(this.bidFormSettings);
            }, this)
        });
    },
    fetchNDA: function (callback) {
        this.nda = new PJQ.models.projects.ProjectNDA({
            project: this
        });
        this.nda.fetch({
            success: _.bind(function () {
                callback(this.nda);
            }, this)
        });
    },
    fetchPunchListItems(callback) {
        return new Promise((resolve, reject) => {
            if (this.punchListItems != null) {
                if (typeof callback === 'function') {
                    callback(this.punchListItems);
                }
                resolve(this.punchListItems);
                return;
            }

            this.punchListItems = new PJQ.collections.punchlists.PunchlistItems(null, {
                project: this
            });
            this.punchListItems.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.punchListItems);
                    }
                    resolve(this.punchListItems);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(this.actionItems);
                    }
                    reject(new Error("Failed to fetch project punchlist items"));
                }
            })
        });
    },
    fetchPunchListCustomFields(callback) {
        return new Promise((resolve, reject) => {
            if (this.punchlistCustomFields != null) {
                resolve(this.punchlistCustomFields);
                if (typeof callback === 'function') {
                    callback(this.punchlistCustomFields);
                }
            }

            this.punchlistCustomFields = new PJQ.collections.punchlists.PunchlistCustomFields(null, {
                project: this
            });
            this.punchlistCustomFields.fetch({
                success: () => {
                    resolve(this.punchlistCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.punchlistCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract field settings"));
                    if (typeof callback === 'function') {
                        callback(this.punchlistCustomFields);
                    }
                }
            })
        });
    },
    fetchRFICustomFields(callback) {
        if (this.rfiCustomFields == null) {
            this.rfiCustomFields = new PJQ.collections.rfi.CustomFields(null, {
                project: this
            });
            this.rfiCustomFields.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.rfiCustomFields);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.rfiCustomFields);
            }
        }
    },
    fetchActionItems(callback) {
        return new Promise((resolve, reject) => {
            if (this.actionItems != null) {
                if (typeof callback === 'function') {
                    callback(this.actionItems);
                }
                resolve(this.actionItems);
                return;
            }

            this.actionItems = new PJQ.collections.actionItems.ActionItems(null, {
                project: this
            });
            this.actionItems.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.actionItems);
                    }
                    resolve(this.actionItems);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(this.actionItems);
                    }
                    reject(new Error("Failed to fetch project action items"));
                }
            })
        });
    },
    fetchActionItemCustomFields(callback) {
        if (this.actionItemCustomFields == null) {
            this.actionItemCustomFields = new PJQ.collections.actionItems.ActionItemCustomFields(null, {
                project: this
            });
            this.actionItemCustomFields.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.actionItemCustomFields);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.actionItemCustomFields);
            }
        }
    },
    fetchSubmittalWorkflowTemplates: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalWorkflowTemplates != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalWorkflowTemplates);
                }
                resolve(this.submittalWorkflowTemplates);
                return;
            }

            this.submittalWorkflowTemplates = new PJQ.collections.submittals.WorkflowTemplates(null, {
                projectId: this.id
            });
            this.submittalWorkflowTemplates.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalWorkflowTemplates);
                    }

                    resolve(this.submittalWorkflowTemplates);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal workflow templates"));
                }
            });
        });
    },
    fetchSubmittalSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalSettings);
                }
                resolve(this.submittalSettings);
                return;
            }

            this.submittalSettings = new PJQ.models.submittals.Settings({
                projectId: this.id
            });
            this.submittalSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalSettings);
                    }

                    resolve(this.submittalSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal settings"));
                }
            });
        });
    },
    fetchSubmittalStatuses: function (refresh, callback) {
        return new Promise((resolve, reject) => {
            if (refresh !== true && this.submittalStatuses != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalStatuses);
                }
                resolve(this.submittalStatuses);
                return;
            }

            this.submittalStatuses = new PJQ.collections.submittals.Statuses(null, {
                projectId: this.id
            });
            this.submittalStatuses.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalStatuses);
                    }

                    resolve(this.submittalStatuses);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal statuses"));
                }
            });
        });
    },
    fetchSubmittalItemTypes: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalItemTypes != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalItemTypes);
                }
                resolve(this.submittalItemTypes);
                return;
            }

            this.submittalItemTypes = new PJQ.collections.submittals.ItemTypes(null, {
                projectId: this.id
            });
            this.submittalItemTypes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.submittalItemTypes);
                    }

                    resolve(this.submittalItemTypes);
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal item types"));
                }
            });
        });
    },
    fetchSubmittalCustomFields(masterUserId, callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalCustomFields);
                }
                resolve(this.submittalCustomFields);
                return;
            }

            this.submittalCustomFields = new PJQ.collections.submittals.SubmittalCustomField(null, {
                projectId: this.id
            });
            this.submittalCustomFields.fetch({
                success: () => {
                    resolve(this.submittalCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.submittalCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal custom fields"));
                }
            });
        });
    },
    fetchSubmittalTemplates: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.submittalTemplates != null) {
                if (typeof callback === 'function') {
                    callback(this.submittalTemplates);
                }
                resolve(this.submittalTemplates);
                return;
            }

            this.submittalTemplates = new PJQ.collections.submittals.Templates(null, {
                projectId: this.id
            });
            this.submittalTemplates.fetch({
                success: () => {
                    resolve(this.submittalTemplates);
                    if (typeof callback === 'function') {
                        callback(this.submittalTemplates);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch submittal templates"));
                }
            });
        });
    },
    fetchActionItemTemplates: function (callback) {
        this.actionItemTemplates = new PJQ.collections.actionItems.Templates();
        this.actionItemTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.actionItemTemplates);
                }
            }, this)
        });
    },
    fetchPunchlistTemplates: function (callback) {
        this.punchlistTemplates = new PJQ.collections.punchlists.Templates();
        this.punchlistTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.punchlistTemplates);
                }
            }, this)
        });
    },
    fetchMeetingTemplates: function (callback) {
        this.meetingTemplates = new PJQ.collections.meetings.Templates();
        this.meetingTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.meetingTemplates);
                }
            }, this)
        });
    },
    fetchActionItemSettings: function (callback) {
        if (this.actionItemSettings == null) {
            this.actionItemSettings = new PJQ.models.actionItems.Settings({
                project: this
            });
            this.actionItemSettings.fetch({
                success: _.bind(function () {
                    callback(this.actionItemSettings);
                }, this)
            });
        } else {
            callback(this.actionItemSettings);
        }
    },
    fetchPunchListSettings: function (callback) {
        if (this.punchlistSettings == null) {
            this.punchlistSettings = new PJQ.models.punchlists.Settings({
                project: this
            });
            this.punchlistSettings.fetch({
                success: _.bind(function () {
                    callback(this.punchlistSettings);
                }, this)
            });
        } else {
            callback(this.punchlistSettings);
        }
    },
    fetchRFIs: function (callback) {
        if (this.rfis == null) {
            this.rfis = new PJQ.collections.rfi.RFIS(null, {
                project: this
            });
            this.rfis.fetch({
                success: _.bind(function () {
                    callback(this.rfis);
                }, this)
            });
        } else {
            callback(this.rfis);
        }
    },
    fetchRFISettings: function (callback) {
        if (this.rfiSettings == null) {
            this.rfiSettings = new PJQ.models.rfi.Settings({
                project: this
            });
            this.rfiSettings.fetch({
                success: _.bind(function () {
                    callback(this.rfiSettings);
                }, this)
            });
        } else {
            callback(this.rfiSettings);
        }
    },
    fetchGalleryPhotos: function (callback) {
        if (this.galleryPhotos == null) {
            this.galleryPhotos = new PJQ.collections.projects.ProjectPhotos(null, {
                project: this
            });
            this.galleryPhotos.fetch({
                success: _.bind(function () {
                    callback(this.galleryPhotos);
                }, this)
            });
        } else {
            callback(this.galleryPhotos);
        }
    },
    fetchProjectCustomFields(callback) {
        if (this.customFields == null) {
            this.customFields = new PJQ.collections.projects.ProjectCustomFields(null, {
                project: this
            });
            this.customFields.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.customFields);
                    }
                }, this)
            })
        } else {
            if (typeof callback === 'function') {
                callback(this.customFields);
            }
        }
    },
    fetchLocations(callback) {
        return new Promise((resolve, reject) => {
            if (this.locations != null) {
                if (typeof callback === 'function') {
                    callback(this.locations);
                }
                resolve(this.locations);
                return;
            }

            this.locations = new PJQ.collections.projects.Locations(null, {
                project: this
            });
            this.locations.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.locations);
                    }
                    resolve(this.locations);
                }, this),
                error: () => {
                    reject(new Error("Failed to fetch project locations"));
                }
            })
        });
    },
    fetchUserMessageTypes(callback) {
        if (this.userMessageTypes == null) {
            this.userMessageTypes = new PJQ.collections.userMessages.UserMessageTypes(null, {
                project: this
            });

            if (PJQ.app.session.contact != null) {
                this.userMessageTypes.fetch({
                    success: _.bind(function () {
                        if (typeof callback === 'function') {
                            callback(this.userMessageTypes);
                        }
                    }, this)
                });
            } else if (typeof callback === 'function') {
                callback(this.userMessageTypes);
            }
        } else {
            if (typeof callback === 'function') {
                callback(this.userMessageTypes);
            }
        }
    },
    fetchScheduleSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleSettings);
                }
                resolve(this.scheduleSettings);
                return;
            }

            this.scheduleSettings = new PJQ.models.schedule.Settings({
                projectId: this.id
            });
            this.scheduleSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleSettings);
                    }
                    resolve(this.scheduleSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch schedule settings"));
                }
            });
        });
    },
    fetchSchedule: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.schedule != null) {
                if (typeof callback === 'function') {
                    callback(this.schedule);
                }
                resolve(this.schedule);
                return;
            }

            this.schedule = new PJQ.models.schedule.Schedule({
                projectId: this.id
            });
            this.schedule.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.schedule);
                    }
                    resolve(this.schedule);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project schedule"));
                }
            });
        });
    },
    fetchScheduleLookAheads: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.scheduleLookAheads != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleLookAheads);
                }
                resolve(this.scheduleLookAheads);
                return;
            }

            this.scheduleLookAheads = new PJQ.collections.schedule.LookAheads([], {
                projectId: this.id
            });

            this.scheduleLookAheads.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleLookAheads);
                    }
                    resolve(this.scheduleLookAheads);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch schedule look-aheads"));
                }
            });
        });

    },
    fetchScheduleNotifications: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (!force && this.scheduleNotifications != null) {
                if (typeof callback === 'function') {
                    callback(this.scheduleNotifications);
                }
                resolve(this.scheduleNotifications);
                return;
            }

            this.scheduleNotifications = new PJQ.collections.schedule.Notifications(null, {
                projectId: this.id
            });
            this.scheduleNotifications.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.scheduleNotifications);
                    }
                    resolve(this.scheduleNotifications);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project schedule notifications"));
                }
            });
        });
    },
    fetchScheduleTemplates: function (callback) {
        this.scheduleTemplates = new PJQ.collections.schedule.Templates();
        this.scheduleTemplates.fetch({
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(this.scheduleTemplates);
                }
            }, this)
        });
    },
    fetchAnnotationLayers: function (callback) {
        if (this.annotationLayers == null) {
            this.annotationLayers = new PJQ.collections.drawings.Layers(null, {
                projectId: this.id
            });
            this.annotationLayers.fetch({
                success: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(this.annotationLayers);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(this.annotationLayers);
            }
        }
    },
    deleteAllPunchLists: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'punchlists'
                }
            ])
        }).delete().done(_.bind(function () {
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    deleteAllActionItems: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'actionitems'
                }
            ])
        }).delete().done(_.bind(function () {
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    deleteAllScheduleTasks: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks'
                }
            ])
        }).delete().done(_.bind(function () {
            if (typeof callback === 'function') {
                if (this.schedule != null) {
                    this.schedule.tasks.reset();
                    this.schedule.dependencies.reset();
                    this.schedule.dependencies.reset();
                    this.schedule.pendingRequestedChanges.reset();
                }
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    getProjectStatuses(callback) {
        if (this.projectStatuses != null) {
            callback(this.projectStatuses);
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.id
                },
                {
                    endpoint: 'statuses'
                }
            ])
        }).get().done(_.bind(function (data) {
            this.projectStatuses = data;
            callback(this.projectStatuses);
        }, this));
    },
    getProjectStatusList() {
        let list = [],
            values = (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_STATUS_LIST)) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_STATUS_LIST) : 'ACCEPT|true,DECLINE|true,BID RECEIVED|false,AWARDED|false';
        _.each(values.split(','), _.bind(function (value) {
            let parts = value.split('|');
            if (parts[0] !== 'PENDING' && parts[0] !== 'UNSENT') {
                list.push([parts[0], parts[1].toLowerCase() === 'true']);
            }
        }, this));
        return list;
    },
    getMessageStatusList() {
        let list = [],
            values = (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.MESSAGE_STATUS_LIST)) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.MESSAGE_STATUS_LIST) : 'YES|true,NO|true';
        _.each(values.split(','), _.bind(function (value) {
            let parts = value.split('|');
            list.push([parts[0], parts[1].toLowerCase() === 'true']);
        }, this));
        return list;
    },
    openInApp: function () {
        let device = PJQ.helpers.mobile.getDevice(),
            storeUrl,
            appRoute;
        if (device === 'android') {
            storeUrl = 'https://play.google.com/store/apps/details?id=com.pantera&hl=en';
        } else {
            storeUrl = 'https://itunes.apple.com/us/app/pantera-mobile/id1208253224?ls=1&mt=8';
        }
        if (PJQ.app.session.contact != null) {
            appRoute = 'pantera://panteratools/project/' + this.id + '/contact/' + PJQ.app.session.contact.id;
        } else {
            appRoute = 'pantera://panteratools/project/' + this.id;
        }
        setTimeout(_.bind(function () {
            window.location = storeUrl;
        }, this), 25);
        window.location = appRoute;
    },
    fetchSubJobs: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.subJobs != null) {
                if (typeof callback === 'function') {
                    callback(this.subJobs);
                }
                resolve(this.subJobs);
                return;
            }

            this.subJobs = new PJQ.collections.budget.SubJobs(null, {
                projectId: this.id
            });
            this.subJobs.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.subJobs);
                    }
                    resolve(this.subJobs);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project sub jobs"));
                }
            });
        });
    },
    fetchCostCodes: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.costCodes != null && !force) {
                if (typeof callback === 'function') {
                    callback(this.costCodes);
                }
                resolve(this.costCodes);
                return;
            }

            this.costCodes = new PJQ.collections.budget.CostCodes(null, {
                projectId: this.id
            });
            this.costCodes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.costCodes);
                    }
                    resolve(this.costCodes);

                    // if (this.get('externalObject') == null) {
                    //     if (typeof callback === 'function') {
                    //         callback(this.costCodes);
                    //     }
                    //     resolve(this.costCodes);
                    //     return;
                    // }

                    // PJQ.app.session.fetchERPIntegration((erp) => {
                    //     if (erp != null && !erp.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES)) {
                    //         let allowedCostCodes = _.filter(this.costCodes.models, (costCode) => {
                    //             return costCode.isERPSynced();
                    //         });
                    //         this.costCodes.reset(allowedCostCodes);
                    //     }
                    //     if (typeof callback === 'function') {
                    //         callback(this.costCodes);
                    //     }
                    //     resolve(this.costCodes);
                    // });
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost codes"));
                }
            });
        });
    },
    fetchCostTypes: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.costTypes != null && !force) {
                if (typeof callback === 'function') {
                    callback(this.costTypes);
                }
                resolve(this.costTypes);
                return;
            }

            this.costTypes = new PJQ.collections.budget.CostTypes(null, {
                projectId: this.id
            });
            this.costTypes.fetch({
                success: () => {
                    if (this.get('externalObject') == null) {
                        if (typeof callback === 'function') {
                            callback(this.costTypes);
                        }
                        resolve(this.costTypes);
                        return;
                    }

                    PJQ.app.session.fetchERPIntegration((erp) => {
                        if (erp != null && !erp.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COST_TYPES)) {
                            let allowedCostTypes = _.filter(this.costTypes.models, (costType) => {
                                return costType.isERPSynced();
                            });
                            this.costTypes.reset(allowedCostTypes);
                        }
                        if (typeof callback === 'function') {
                            callback(this.costTypes);
                        }
                        resolve(this.costTypes);
                    });
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project cost types"));
                }
            })
        });
    },
    fetchTaxCodes: function (callback, force) {
        return new Promise((resolve, reject) => {
            if (this.taxCodes != null) {
                if (typeof callback === 'function') {
                    callback(this.taxCodes);
                }
                resolve(this.taxCodes);
                return;
            }

            this.taxCodes = new PJQ.collections.budget.TaxCodes(null, {
                projectId: this.id
            });
            this.taxCodes.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.taxCodes);
                    }

                    resolve(this.taxCodes);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch tax codes"));
                }
            })
        });
    },
    fetchUnitsOfMeasure: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.unitsOfMeasure != null) {
                if (typeof callback === 'function') {
                    callback(this.unitsOfMeasure);
                }
                resolve(this.unitsOfMeasure);
                return;
            }

            this.unitsOfMeasure = new PJQ.collections.budget.UnitsOfMeasure(null, {
                projectId: this.id
            });
            this.unitsOfMeasure.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.unitsOfMeasure);
                    }

                    resolve(this.unitsOfMeasure);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch units of measure"));
                }
            })
        });
    },
    fetchBudgetTimeStats: function (callback, options) {
        return new Promise((resolve, reject) => {
            // if (this.budgetTimeStats != null && (options == null || options.force !== true)) {
            //     if (typeof callback === 'function') {
            //         callback(this.budget);
            //     }
            //     resolve(this.budget);
            //     return;
            // }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: this.id,
                    },
                    {
                        endpoint: 'timecards'
                    },
                    {
                        endpoint: 'stats'
                    }
                ]),
                isAPIv2: true
            }).get().done((data) => {
                if (typeof callback === 'function') {
                    callback(data);
                }
                resolve(data);
            }).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(null);
            });
        });
    },
    fetchBudget: function (callback, options) {
        return new Promise((resolve, reject) => {
            if (this.budget != null && (options == null || options.force !== true)) {
                if (typeof callback === 'function') {
                    callback(this.budget);
                }
                resolve(this.budget);
                return;
            }

            this.budget = new PJQ.models.budget.Budget({
                projectId: this.id
            });
            this.budget.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.budget);
                    }

                    resolve(this.budget);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project budget"));
                }
            })
        });
    },
    fetchBudgetViews: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.budgetViews != null) {
                if (typeof callback === 'function') {
                    callback(this.budgetViews);
                }
                resolve(this.budgetViews);
                return;
            }

            this.budgetViews = new PJQ.collections.budget.BudgetViews();
            this.budgetViews.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.budgetViews);
                    }

                    resolve(this.budgetViews);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project budget views"));
                }
            })
        });
    },
    fetchBudgetSnapshots: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.snapshots != null) {
                if (typeof callback === 'function') {
                    callback(this.snapshots);
                }
                resolve(this.snapshots);
                return;
            }

            this.snapshots = new PJQ.collections.budget.Snapshots(null, {
                projectId: this.id
            });
            this.snapshots.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.snapshots);
                    }

                    resolve(this.snapshots);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch project budget snapshots"));
                }
            })
        });
    },
    fetchCommitmentSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentSettings);
                }
                resolve(this.commitmentSettings);
                return;
            }

            this.commitmentSettings = new PJQ.models.commitments.Settings({}, {
                projectId: this.id
            });
            this.commitmentSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentSettings);
                    }

                    resolve(this.commitmentSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment settings"));
                }
            });
        });
    },
    fetchCommitmentFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentFieldSettings);
                }
                resolve(this.commitmentFieldSettings);
                return;
            }

            this.commitmentFieldSettings = new PJQ.collections.commitments.FieldSettings(null, {
                projectId: this.id
            });
            this.commitmentFieldSettings.fetch({
                success: () => {
                    resolve(this.commitmentFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.commitmentFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment field settings"));
                }
            });
        });
    },
    fetchCommitmentTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentTerms);
                }
                resolve(this.commitmentTerms);
                return;
            }

            this.commitmentTerms = new PJQ.collections.commitments.Terms(null, {
                projectId: this.id
            });
            this.commitmentTerms.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentTerms);
                    }

                    resolve(this.commitmentTerms);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment terms"));
                }
            });
        });
    },
    fetchCommitmentCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentCustomFields);
                }
                resolve(this.commitmentCustomFields);
                return;
            }

            this.commitmentCustomFields = new PJQ.collections.commitments.CustomFields(null, {
                projectId: this.id
            });
            this.commitmentCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentCustomFields);
                    }

                    resolve(this.commitmentCustomFields);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch commitment custom fields"));
                }
            });
        });
    },
    fetchDirectCostCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.directCostCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.directCostCustomFields);
                }
                resolve(this.directCostCustomFields);
                return;
            }

            this.directCostCustomFields = new PJQ.collections.directcosts.CustomFields(null, {
                projectId: this.id
            });
            this.directCostCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.directCostCustomFields);
                    }

                    resolve(this.directCostCustomFields);
                },
                error: () => {
                    reject(new Error("Failed to fetch direct cost custom fields"));
                }
            });
        });
    },
    fetchMeetingCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.meetingCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.meetingCustomFields);
                }
                resolve(this.meetingCustomFields);
                return;
            }

            this.meetingCustomFields = new PJQ.collections.meetings.CustomFields(null, {
                projectId: this.id
            });
            this.meetingCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.meetingCustomFields);
                    }

                    resolve(this.meetingCustomFields);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch meeting custom fields"));
                }
            });
        });
    },
    fetchMeetingSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.meetingSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.meetingSettings);
                }
                resolve(this.meetingSettings);
                return;
            }

            this.meetingSettings = new PJQ.models.meetings.Settings(null, {
                projectId: this.id
            });
            this.meetingSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.meetingSettings);
                    }

                    resolve(this.meetingSettings);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch meeting settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderSettings);
                }
                resolve(this.commitmentChangeOrderSettings);
                return;
            }

            this.commitmentChangeOrderSettings = new PJQ.models.commitments.ChangeOrderSettings({}, {
                projectId: this.id
            });
            this.commitmentChangeOrderSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderSettings);
                    }

                    resolve(this.commitmentChangeOrderSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentChangeOrderFieldSettings);
                }
                resolve(this.commitmentChangeOrderFieldSettings);
                return;
            }

            this.commitmentChangeOrderFieldSettings = new PJQ.collections.commitments.ChangeOrderFieldSettings(null, {
                projectId: this.id
            });
            this.commitmentChangeOrderFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentChangeOrderFieldSettings);
                    }

                    resolve(this.commitmentChangeOrderFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch commitment change order field settings"));
                }
            });
        });
    },
    fetchCommitmentChangeOrderCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.commitmentCOCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.commitmentCOCustomFields);
                }
                resolve(this.commitmentCOCustomFields);
                return;
            }

            this.commitmentCOCustomFields = new PJQ.collections.commitments.ChangeOrderCustomFields(null, {
                projectId: this.id
            });
            this.commitmentCOCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.commitmentCOCustomFields);
                    }

                    resolve(this.commitmentCOCustomFields);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch commitment change order custom fields"));
                }
            });
        });
    },
    fetchPrimeContractFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractFieldSettings);
                }
                resolve(this.primeContractFieldSettings);
                return;
            }

            this.primeContractFieldSettings = new PJQ.collections.primeContracts.FieldSettings(null, {
                projectId: this.id
            });
            this.primeContractFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract field settings"));
                }
            });
        });
    },
    fetchPrimeContractTerms: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractTerms != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractTerms);
                }
                resolve(this.primeContractTerms);
                return;
            }

            this.primeContractTerms = new PJQ.collections.primeContracts.Terms(null, {
                projectId: this.id
            });
            this.primeContractTerms.fetch({
                success: () => {
                    resolve(this.primeContractTerms);
                    if (typeof callback === 'function') {
                        callback(this.primeContractTerms);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract terms"));
                }
            });
        });
    },
    fetchPrimeContractSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractSettings);
                }
                resolve(this.primeContractSettings);
                return;
            }

            this.primeContractSettings = new PJQ.models.primeContracts.Settings({}, {
                projectId: this.id
            });
            this.primeContractSettings.fetch({
                success: () => {
                    resolve(this.primeContractSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract settings "));
                }
            });
        });
    },
    fetchPrimeContractCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractCustomFields);
                }
                resolve(this.primeContractCustomFields);
                return;
            }

            this.primeContractCustomFields = new PJQ.collections.primeContracts.CustomFields(null, {
                projectId: this.id
            });
            this.primeContractCustomFields.fetch({
                success: () => {
                    resolve(this.primeContractCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.primeContractCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract custom fields"));
                }
            });
        });
    },
    fetchPayableInvoiceSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceSettings);
                }
                resolve(this.payableInvoiceSettings);
                return;
            }

            this.payableInvoiceSettings = new PJQ.models.invoicing.PayableInvoiceSettings(null, {
                projectId: this.id
            });
            this.payableInvoiceSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceSettings);
                    }

                    resolve(this.payableInvoiceSettings);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(null);
                    }
                    reject(new Error("Failed to fetch payable invoice settings"));
                }
            });
        });
    },
    fetchPayableInvoiceFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceFieldSettings);
                }
                resolve(this.payableInvoiceFieldSettings);
                return;
            }

            this.payableInvoiceFieldSettings = new PJQ.collections.invoicing.PayableInvoiceFieldSettings(null, {
                projectId: this.id
            });
            this.payableInvoiceFieldSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceFieldSettings);
                    }

                    resolve(this.payableInvoiceFieldSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice field settings"));
                }
            });
        });
    },
    fetchPayableInvoiceCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.payableInvoiceCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.payableInvoiceCustomFields);
                }
                resolve(this.payableInvoiceCustomFields);
                return;
            }

            this.payableInvoiceCustomFields = new PJQ.collections.invoicing.PayableInvoiceCustomFields(null, {
                projectId: this.id
            });
            this.payableInvoiceCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.payableInvoiceCustomFields);
                    }

                    resolve(this.payableInvoiceCustomFields);
                },
                error: () => {
                    reject(new Error("Failed to fetch payable invoice custom fields"));
                }
            });
        });
    },
    fetchReceivableInvoiceSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceSettings);
                }
                resolve(this.receivableInvoiceSettings);
                return;
            }

            this.receivableInvoiceSettings = new PJQ.models.invoicing.ReceivableInvoiceSettings();
            this.receivableInvoiceSettings.fetch({
                success: () => {
                    resolve(this.receivableInvoiceSettings);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice settings "));
                }
            });
        });
    },
    fetchReceivableInvoiceCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.receivableInvoiceCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.receivableInvoiceCustomFields);
                }
                resolve(this.receivableInvoiceCustomFields);
                return;
            }

            this.receivableInvoiceCustomFields = new PJQ.collections.invoicing.ReceivableInvoiceCustomFields(null, {
                projectId: this.id
            });
            this.receivableInvoiceCustomFields.fetch({
                success: () => {
                    resolve(this.receivableInvoiceCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.receivableInvoiceCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch receivable invoice custom fields"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderFieldSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderFieldSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderFieldSettings);
                }
                resolve(this.primeContractChangeOrderFieldSettings);
                return;
            }

            this.primeContractChangeOrderFieldSettings = new PJQ.collections.primeContracts.ChangeOrderFieldSettings(null, {
                projectId: this.id
            });
            this.primeContractChangeOrderFieldSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderFieldSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderFieldSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order field settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractChangeOrderSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractChangeOrderSettings);
                }
                resolve(this.primeContractChangeOrderSettings);
                return;
            }

            this.primeContractChangeOrderSettings = new PJQ.models.primeContracts.ChangeOrderSettings({}, {
                projectId: this.id
            });
            this.primeContractChangeOrderSettings.fetch({
                success: () => {
                    resolve(this.primeContractChangeOrderSettings);
                    if (typeof callback === 'function') {
                        callback(this.primeContractChangeOrderSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order settings"));
                }
            });
        });
    },
    fetchPrimeContractChangeOrderCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.primeContractCOCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.primeContractCOCustomFields);
                }
                resolve(this.primeContractCOCustomFields);
                return;
            }

            this.primeContractCOCustomFields = new PJQ.collections.primeContracts.ChangeOrderCustomFields(null, {
                projectId: this.id
            });
            this.primeContractCOCustomFields.fetch({
                success: () => {
                    resolve(this.primeContractCOCustomFields);
                    if (typeof callback === 'function') {
                        callback(this.primeContractCOCustomFields);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch contract change order custom custom fields"));
                }
            });
        });
    },
    fetchChangeRequestSettings: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestSettings != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestSettings);
                }
                resolve(this.changeRequestSettings);
                return;
            }

            this.changeRequestSettings = new PJQ.models.changeRequests.Settings({}, {
                projectId: this.id
            });
            this.changeRequestSettings.fetch({
                success: () => {
                    resolve(this.changeRequestSettings);
                    if (typeof callback === 'function') {
                        callback(this.changeRequestSettings);
                    }
                },
                error: () => {
                    reject(new Error("Failed to fetch change request settings"));
                }
            });
        });
    },
    fetchChangeRequestCustomFields: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.changeRequestCustomFields != null) {
                if (typeof callback === 'function') {
                    callback(this.changeRequestCustomFields);
                }
                resolve(this.changeRequestCustomFields);
                return;
            }

            this.changeRequestCustomFields = new PJQ.collections.changeRequests.CustomFields(null, {
                projectId: this.id
            });
            this.changeRequestCustomFields.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.changeRequestCustomFields);
                    }

                    resolve(this.changeRequestCustomFields);
                },
                error: () => {
                    reject(new Error("Failed to fetch change request custom fields"));
                }
            });
        });
    },
    fetchBillingPeriodSettings: function (callback, allowAutomate = false) {
        return new Promise((resolve, reject) => {
            if (this.billingPeriodSettings != null) {
                if (allowAutomate && !this.billingPeriodSettings.get('allowAutomate')) {
                    this.billingPeriodSettings.set('allowAutomate', allowAutomate);
                    fnFetch();
                }

                if (typeof callback === 'function') {
                    callback(this.billingPeriodSettings);
                }
                resolve(this.billingPeriodSettings);
                return;
            }

            this.billingPeriodSettings = new PJQ.models.budget.BillingPeriodSettings({
                projectId: this.id,
                allowAutomate: allowAutomate
            });
            this.billingPeriodSettings.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.billingPeriodSettings);
                    }

                    resolve(this.billingPeriodSettings);
                },
                error: () => {
                    reject(new Error("Failed to fetch billing period settings"));
                }
            });
        });
    },
});

PJQ.models.projects.ProjectCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'customfields',
                value: this.id
            }
        ]);
    },
});

PJQ.models.projects.ProjectSettings = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parse: function (model) {
        return model;
    },
    isColumnSelected: function (column) {
        return (_.find(this.get('columns'), function (col) {
            return col === column
        }) !== undefined);
    }
});

//right now this model is 100% cookie based
PJQ.models.projects.ProjectInvitesSettings = PJQ.models.BaseModel.extend({
    setFavoriteFilter: function (val) {
        if (val) {
            PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.PROJECT_INVITES_FAVORITE_FILTER, true);
        } else {
            PJQ.helpers.cookieHelpers.removeCookie(PJQ.constants.cookies.PROJECT_INVITES_FAVORITE_FILTER);
        }
    },
    getFavoriteFilter: function () {
        return PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.PROJECT_INVITES_FAVORITE_FILTER) === "true";
    }
});

//Collections
PJQ.collections.projects.Projects = PJQ.collections.BaseCollection.extend({
    options: {
        isSimple: true,
        isBidding: false,
        customFieldIds: [],
        isMyProjects: false,
        isProjectInvites: false
    },
    model: PJQ.models.projects.Project,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            }
        ], [
            {
                parameter: 'isSimple',
                value: this.options.isSimple
            },
            {
                parameter: 'isBidding',
                value: this.options.isBidding
            },
            {
                parameter: 'status',
                value: this.options.status
            },
            {
                parameter: 'customFieldIds',
                value: this.options.customFieldIds
            },
            {
                parameter: 'isMyProjects',
                value: this.options.isMyProjects
            },
            {
                parameter: 'isProjectInvites',
                value: this.options.isProjectInvites
            }
        ])
    }
});

PJQ.collections.projects.ProjectPhotos = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.files.File,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'photos'
            }
        ])
    }
});

PJQ.collections.projects.ProjectCustomFields = PJQ.collections.customFields.CustomFields.extend({
    model: PJQ.models.projects.ProjectCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project ? this.options.project.id : null
            },
            {
                endpoint: 'customfields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

//Views
PJQ.views.projects.ProjectParticipantHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Participant-History'),
        subTemplates: {
            singleProjectHistory: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Participant-Single-Project-History'),
            overallHistory: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Participant-Overall-History'),
        },
        isShowCloseButton: true,
        maxWidth: '1000px',
        type: 'THIS',
        onGoToProject: _.noop
    },
    events: {
        'keyup .input-history-search': 'search',
        'click .link-project': 'goToProject',
        'click .btn-copy-access-key': 'copyAccessKey',
        'click .btn-view-downloads': 'viewDownloads',
        'click .btn-export': 'export',
        'click .btn-show-message': 'showProjectMessage'
    },
    beforeModalCreated: function () {
        this.options.project = PJQ.app.session.project;
    },
    search: function () {
        this.$('.datatable-search').val(this.$('.input-history-search').val());
    },
    getContextMenuItems: function () {
        return [
            {
                name: 'Resend Message',
                iconClass: 'fal fa-paper-plane',
                onClick: _.bind(function (row) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id
                            },
                            {
                                endpoint: 'projectmessages',
                                value: row.data().projectMessageId
                            },
                            {
                                endpoint: 'resend'
                            }
                        ], [
                            {
                                parameter: 'projectMessageContactBroadcastIds',
                                value: [row.data().projectMessageContactBroadcastId]
                            }
                        ])
                    }).post().done(_.bind(function (data) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Message is being resent.'
                        });
                    }, this));

                }, this),
                isShown: _.bind(function (row) {
                    let data = row.data();
                    return data.projectMessageContactBroadcastId > 1 && data.auditAction.toLowerCase() === 'projectmessage';
                }, this)
            }
        ];
    },
    afterRender: function () {
        if (this.options.project) {
            this.historyTypeSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.history-type'),
                onChange: _.bind(function (value) {
                    this.renderHistory(value);
                }, this)
            });
            this.options.project.getProjectStatuses(_.bind(function (statuses) {
                this.statuses = statuses;
                this.renderHistory(this.options.type);
            }, this));
        } else {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'settings'
                    },
                    {
                        endpoint: 'statuses'
                    }
                ])
            }).get().done(_.bind(function (data) {
                this.statuses = data;
                this.$('.select-project-history-type').hide();
                this.renderHistory('ALL');
            }, this)).fail(_.bind(function () {
                this.statuses = null;
                this.$('.select-project-history-type').hide();
                this.renderHistory('ALL');
            }, this));
        }
    },
    renderHistory: function (type) {
        let $history = this.$('.history-data');
        if (type === 'THIS') {
            this.renderSubTemplate(false, this.options.subTemplates.singleProjectHistory, $history, {}, _.bind(function () {
                if (this.singleProjectData == null) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: "projects",
                                value: this.options.project.id
                            },
                            {
                                endpoint: "participants",
                                value: this.options.contactId
                            },
                            {
                                endpoint: "history"
                            }
                        ])
                    }).get().done(_.bind(function (data) {
                        this.singleProjectData = data;
                        this.renderSingleProjectHistory();
                    }, this));
                } else {
                    this.renderSingleProjectHistory();
                }
            }, this));
        } else {
            let loader = new PJQ.Loader($history);
            let callback = _.bind(function (data) {
                this.overallData = data;
                this.renderSubTemplate(false, this.options.subTemplates.overallHistory, $history, {
                    statuses: _.uniq(_.map(this.overallData, function (project) {
                        return (_.size(project.projectStatus) > 0 ? project.projectStatus.toUpperCase() : "PENDING");
                    }))
                }, _.bind(function () {
                    this.renderOverallHistory();
                    loader.remove();
                }, this));
            }, this);
            if (this.overallData == null) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: "contacts",
                            value: this.options.contactId
                        },
                        {
                            endpoint: "projecthistory"
                        }
                    ])
                }).get().done(callback);
            } else {
                callback(this.overallData);
            }
        }
    },
    getStatusColor: function (name) {
        let status = _.find(this.statuses, function (status) {
            return status.name.toUpperCase() === name.toUpperCase();
        });

        return status != null ? status.backgroundColor : "#eee";
    },
    renderSingleProjectHistory: function () {
        _.each(this.singleProjectData, _.bind(function (data) {
            if (data.auditAction === 'MessageKeyDownload')
                this.$('.btn-view-downloads').removeClass('hidden');
        }, this));

        let responseDueLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due";
        new PJQ.views.dataTables.DataTable({
            el: this.$('.single-project-data-table'),
            rowId: 'projectMessageContactBroadcastId',
            pageLength: 5,
            isHideSearch: true,
            data: this.singleProjectData,
            dom: "<'row no-gutters'<'table-outer col-sm-12'tr>>" + "<'row no-gutters'<'col-sm-5 mt-1'l><'col-sm-7 mt-2'p>>",
            contextMenuOptions: {
                actions: this.getContextMenuItems(),
                isHideNoActions: true
            },
            order: [0, 'desc'],
            columns: [
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.created);
                        },
                        "filter": "created",
                        "display": function (row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                    },
                    "title": "Date",
                    "orderable": false
                },
                {
                    "data": "description",
                    "title": "Description",
                    "width": '300px',
                    "orderable": false,
                    "render": function (data, type, row) {
                        if (row.auditAction === "ProjectMessage" || row.auditAction === "PrivateMessage") {
                            if (row.subject != null) {
                                return '<a href="javascript:void(0)" data-id=" ' + row.projectMessageId + '" class="btn-show-message" title="Click to view Message">' + row.subject + '</a>'
                            } else {
                                return data;
                            }
                        } else {
                            return data;
                        }
                    }
                },
                {
                    "data": {
                        "_": function (row) {
                            let result = (row.auditAction === 'ProjectMessage' ? 'No Response Required' : 'N/A');
                            switch (row.messageType) {
                                case 'PROJECT':
                                    result = 'ACCEPT/DECLINE';
                                    break;
                                case 'MESSAGE':
                                    result = 'YES/NO';
                                    break;
                            }
                            return result;
                        }
                    },
                    "title": "Response Type",
                    "orderable": false
                },
                {
                    "data": {
                        "_": function (row) {
                            let result = 'N/A';
                            if (row.auditAction === 'ProjectMessage') {
                                result = row.bidDueDate;

                                if (!row.bidDueTime.startsWith(' ')) {
                                    result += ' ' + row.bidDueTime + ' ' + row.bidDueTimeZone;
                                }
                            }
                            return result;
                        }
                    },
                    "title": responseDueLabel,
                    "orderable": false
                },
                {
                    "data": "accessKey",
                    "title": "Access Key",
                    "orderable": false,
                    "render": function (data, type, row) {
                        let html = '<div style="min-width:100px;" class="d-flex align-items-center">';
                        html += '<div class="flex-fill ' + (row.accessKey ? '' : 'text-muted') + '">' + (row.accessKey ? row.accessKey : '') + '</div>';
                        if (_.size(row.accessKey) > 0)
                            html += '<button type="button" class="btn btn-transparent-dark btn-copy-access-key" title="Copy Access Key" data-access-key="' + row.accessKey + '"><i class="far fa-key text-dark"></i></button>';
                        html += '</div>';
                        return html;
                    }

                },
                {
                    "data": "broadcastStatus",
                    "title": 'Broadcast Status',
                    "render": function (data, type, row) {
                        let broadcastStatus = row.auditAction === 'ProjectMessage' ? (_.size(row.broadcastStatus) === 0 ? 'PENDING' : row.broadcastStatus) : '';
                        return '<span title="' + (_.size(row.broadcastErrorMessage) === 0 ? broadcastStatus : row.broadcastErrorMessage) + '" >' + broadcastStatus + '</span>';
                    },
                    "orderable": false
                },
                {
                    "data": "response",
                    "title": 'Response',
                    "render": _.bind(function (data, type, row) {
                        let response = 'N/A';
                        if (_.size(row.response) > 0) {
                            response = '<span style="color:' + this.getStatusColor(row.response) + '">' + row.response + '</span>';
                        }
                        return response;
                    }, this),
                    "orderable": false
                },
                {
                    "data": "responded",
                    "title": 'Responded',
                    "render": function (data, type, row) {
                        let response = 'N/A';
                        if (row.auditAction === 'ProjectMessage') {
                            response = '';
                            if (_.size(row.responded) > 0)
                                response = PJQ.helpers.dateHelpers.getDateString(new Date(row.responded), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                        }
                        return response;
                    },
                    "orderable": false
                }
            ]
        });
    },
    renderOverallHistory: function () {
        let statuses = {},
            statusesDatasets = [],
            responses = {
                responded: 0,
                notResponded: 0
            };
        _.each(this.overallData, function (project) {
            let status = _.size(project.projectStatus) > 0 ? project.projectStatus.toUpperCase() : "PENDING";
            if (statuses[status] == null) {
                statuses[status] = 1;
            } else {
                statuses[status] = statuses[status] + 1;
            }

            if (status === "PENDING") {
                responses.notResponded = responses.notResponded + 1;
            } else {
                responses.responded = responses.responded + 1;
            }
        });
        _.each(statuses, function (count, status) {
            let set = {
                label: status,
                backgroundColor: this.getStatusColor(status),
                data: [
                    count
                ]
            };
            statusesDatasets.push(set);
        }, this);
        new PJQ.charts.Chart(this.$('.statuses-chart'), {
            type: 'bar',
            height: 250,
            width: 250,
            data: {
                datasets: statusesDatasets
            },
            options: {
                cutoutPercentage: 70,
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0
                        }
                    }]
                }
            },
            onClick: _.bind(function (clickedSegments) {
                if (_.size(clickedSegments) > 0) {
                    let segment = clickedSegments[0],
                        stat = stats.datasets[segment._index];
                    PJQ.app.router.navigate('projects/' + this.options.project.id + '/' + stat.route, {
                        trigger: true
                    });
                }
            }, this)
        });

        let responsesLabels = ["Responded", "Not Responded"],
            responsesDataset = [responses["responded"], responses["notResponded"]],
            responsesColors = [PJQ.constants.colors.BLUE, PJQ.constants.colors.GRAY];
        new PJQ.charts.Chart(this.$('.responses-chart'), {
            type: 'doughnut',
            height: 250,
            width: 250,
            options: {
                cutoutPercentage: 70
            },
            data: {
                labels: responsesLabels,
                datasets: [
                    {
                        data: responsesDataset,
                        backgroundColor: responsesColors
                    }
                ]
            },
            onClick: _.bind(function (clickedSegments) {
                if (_.size(clickedSegments) > 0) {
                    let segment = clickedSegments[0],
                        stat = stats.datasets[segment._index];
                    PJQ.app.router.navigate('projects/' + this.options.project.id + '/' + stat.route, {
                        trigger: true
                    });
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-history-filter'),
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {

            }, this)
        });
        let prefs;
        if (PJQ.app.session.project != null) {
            prefs = PJQ.app.session.project.preferences;
        } else {
            prefs = PJQ.app.session.preferences;
        }

        let responseDueLabel = prefs.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due",
            startDateLabel,
            finishDateLabel;
        if (this.options.project) {
            startDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) : 'Start Date'
            finishDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) : 'Finish Date';
        } else {
            startDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) : 'Start Date'
            finishDateLabel = prefs.hasPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) ? prefs.getPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) : 'Finish Date';
        }
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.overall-data-table'),
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Participant-Overall-History')
            },
            headerData: _.bind(function () {
                return {
                    statuses: this.statuses,
                    getStatusColor: this.getStatusColor
                };
            }, this),
            afterHeaderRender: function (view, $header) {
                new PJQ.inputs.Selectpicker({
                    el: $header.find('.select-history-filter'),
                    onChange: function (value) {
                        view.setFilter('status', value);
                    },
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });
            },
            getFilterData: function (view, data) {
                let statusFilter = view.getFilter('status');
                if (_.size(statusFilter) > 0) {
                    return _.filter(data, function (item) {
                        return statusFilter.indexOf(item.projectStatus.toLowerCase()) !== -1;
                    });
                }
                return data;
            },
            pageLength: 10,
            data: this.overallData,
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            order: [],
            columns: [
                {
                    "data": "projectName",
                    "title": 'Name',
                    "render": _.bind(function (data, type, row) {
                        return '<a class="link-project" href="/#projects/' + row.projectId.toString() + '/dashboard">' + data + '</a>';
                    }, this)
                },
                {
                    "data": "city",
                    "title": 'City'
                },
                {
                    "data": "projectStatus",
                    "title": 'Status',
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let status = _.size(row.projectStatus) > 0 ? row.projectStatus.toUpperCase() : 'PENDING';
                        return '<span style="color:' + this.getStatusColor(status) + '">' + status + '</span>';
                    }, this)
                },
                {
                    "data": {
                        "_": function (row) {

                            let dateTemp = new Date();
                            if (row.responseDue == null || row.responseDue == 'N/A')
                                return dateTemp.addDays(-20000);
                            if (row.responseDue === 'ASAP')
                                return dateTemp.addDays(-10000);

                            return new Date(row.responseDue);
                        },
                        "filter": "responseDue",
                        "display": function (row) {
                            if (row.responseDue == null || row.responseDue == 'N/A')
                                return "N/A";
                            if (row.responseDue === 'ASAP')
                                return row.responseDue;

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.responseDue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    "title": responseDueLabel
                },
                {
                    "data": {
                        "_": function (row) {

                            let dateTemp = new Date();
                            if (row.startDate == null)
                                return dateTemp.addDays(-20000);

                            return new Date(row.startDate);
                        },
                        "filter": "startDate",
                        "display": function (row) {
                            if (row.startDate == null)
                                return "N/A";

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.startDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    "title": startDateLabel
                },
                {
                    "data": {
                        "_": function (row) {

                            let dateTemp = new Date();
                            if (row.endDate == null)
                                return dateTemp.addDays(-20000);

                            return new Date(row.endDate);
                        },
                        "filter": "endDate",
                        "display": function (row) {
                            if (row.endDate == null)
                                return "N/A";

                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.endDate), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }
                    },
                    "title": finishDateLabel
                },
                {
                    "data": "emailSuccessCount",
                    "title": "Sent/Failed",
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        return '' + (row.emailSuccessCount + row.faxSuccessCount).toString() + ' / ' + (row.emailFailedCount + row.faxFailedCount).toString();
                    }, this)
                }
            ]
        });
    },
    goToProject: function () {
        this.removeModal();
        if (this.options.onGoToProject) {
            this.options.onGoToProject();
        }
    },
    showProjectMessage: function (e) {
        let $target = $(e.currentTarget),
            message = _.find(this.singleProjectData, function (data) {
                return data.projectMessageId === parseInt($target.data('id'));
            });
        e.target.outerHTML = message.description;
    },
    copyAccessKey: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('accessKey'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Access Key copied to clipboard.'
        });
    },
    viewDownloads: function () {
        new PJQ.views.projects.ProjectParticipantDownloadHistoryModal({
            contactId: this.options.contactId
        });
    },
    export: function () {
        if (this.historyTypeSelectPicker != null && this.historyTypeSelectPicker.getValue() === 'THIS') {
            PJQ.files.downloadFile(
                PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'participants',
                        value: this.options.contactId
                    },
                    {
                        endpoint: 'history'
                    },
                    {
                        endpoint: 'export'
                    }
                ])
            );
        } else {
            PJQ.files.downloadFile(
                PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: "contacts",
                        value: this.options.contactId
                    },
                    {
                        endpoint: "projecthistory"
                    },
                    {
                        endpoint: "export"
                    }
                ])
            );
        }
    }

});

PJQ.views.projects.ProjectParticipantDownloadHistoryModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Project-Participant-Download-History'),
        minWidth: '900px'
    },
    events: {
        'click .btn-export': 'export'
    },
    beforeModalCreated: function () {
        this.options.project = PJQ.app.session.project;
    },
    afterRender: function () {
        // build endpoint and fetch
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'participants',
                value: this.options.contactId
            },
            {
                endpoint: 'downloadhistory'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
        }).get().done(_.bind(function (data) {
            new PJQ.views.dataTables.DataTable({
                el: this.$('.download-table'),
                pageLength: 5,
                isHideSearch: true,
                data: data,
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
                order: [],
                columns: [
                    {
                        "data": "title",
                        "title": "Filename",
                        "orderable": false
                    },
                    {
                        "data": {
                            "_": function (row) {
                                return new Date(row.downloadedOn);
                            },
                            "display": function (row) {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.downloadedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                            }
                        },
                        "title": "Downloaded On",
                        "orderable": false
                    }
                ]
            });
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong.'
            });
        });

    },
    export: function () {
        PJQ.files.downloadFile(
            PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'participants',
                    value: this.options.contactId
                },
                {
                    endpoint: 'downloadhistory'
                },
                {
                    endpoint: 'export'
                }
            ])
        );
    }
});


PJQ.views.projects.ProjectSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Selector'),
        isDisableSelected: false,
        isSingleChoice: false,
        onProjectSelected: _.noop,
        excludeProjectIds: [],
        dataTableHeaderData: {
            isHideDeletedFilter: false
        },
        dataTableColumns: null
    },
    events: {
        "change .select-project": "selectProject"
    },
    beforeFirstRender: function () {

        if (this.options.dataTableColumns === null)
            this.options.dataTableColumns = [
                {name: 'projectName', sort: 1},
                {name: 'city', sort: 0},
                {name: 'state', sort: 0}
            ];

        if (!this.options.isSingleChoice) {
            this.selectedProjects = [];
        }

        this.collection = new PJQ.collections.projects.Projects();
        this.listenTo(this.collection, 'sync', this.render);
        this.collection.fetch();
    },
    afterRender: function () {
        let order = null;
        _.each(this.options.dataTableColumns, _.bind(function (column, index) {
            if (column.sort !== 0)
                order = [index + 1, column.sort === 1 ? 'asc' : 'desc'];
        }, this));

        this.dataTable = new PJQ.views.projects.ProjectSelectorDataTable({
            el: '.projects-data-table-container',
            data: _.filter(this.collection.models, _.bind(function (model) {
                return this.options.excludeProjectIds.indexOf(model.id) === -1
            }, this)),
            columns: this.getColumns(),
            order: order,
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Selector')
            },
            headerData: this.options.dataTableHeaderData
        });
    },
    getColumns: function () {
        let columns = [
            {
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            }
        ];

        _.each(this.options.dataTableColumns, _.bind(function (column, index) {

            switch (column.name) {
                case 'projectId':
                    columns.push({
                        "data": "attributes.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "data": "attributes.projectName",
                        "title": "Project Name"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'created':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return new Date(row.attributes.created);
                            },
                            "filter": "attributes.created",
                            "display": function (row) {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                            }
                        },
                        "title": "Created"
                    });
                    break;
                case 'bidsdue':
                    let responseDueLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due";
                    columns.push({
                        "data": {
                            "_": function (row) {

                                let dateTemp = new Date();
                                if (row.attributes.bidsDue == null)
                                    return dateTemp.addDays(-20000);
                                if (row.attributes.rDueText === 'ASAP')
                                    return dateTemp.addDays(-10000);

                                return new Date(row.attributes.bidsDue);
                            },
                            "filter": "attributes.bidsDue",
                            "display": function (row) {
                                if (row.attributes.bidsDue == null)
                                    return "N/A";
                                if (row.attributes.rDueText === 'ASAP')
                                    return row.attributes.rDueText;

                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }
                        },
                        "title": responseDueLabel
                    });
                    break;
                case 'userDisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact"
                    });
                    break;
                case 'user2DisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2"
                    });
                    break;
            }
        }, this));

        return columns;
    },
    selectProject: function (e) {
        let target = $(e.currentTarget),
            project = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-project').not(target).text('Select').prop('checked', false); //.removeClass('btn-primary').addClass('btn-secondary');
            if (project.get('isSelected')) {
                project.set('isSelected', false);
                this.selectedProject = null;
            } else {
                project.set('isSelected', true);
                this.selectedProject = project;
                this.collection.get(project.id);
                _.each(this.collection.models, _.bind(function (dtProject) {
                    if (project.id !== dtProject.id)
                        dtProject.set('isSelected', false);
                }, this));
            }

            this.options.onProjectSelected(this.selectedProject);
        } else {
            if (project.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                project.set('isSelected', false);
                this.selectedProjects = _.reject(this.selectedProjects, function (selProject) {
                    return selProject.id === project.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                project.set('isSelected', true);
                this.selectedProjects.push(project);
            }
            this.options.onProjectSelected(this.selectedProjects);
        }
    }
});

PJQ.views.projects.ProjectSelectorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-project-select'),
        width: '40%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: false,
        isSingleChoice: false,
        onSave: _.noop(),
        excludeProjects: null,
        excludeProjectIds: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
    },
    afterRender: function () {
        this.projects = null;

        new PJQ.views.projects.ProjectSelector({
            el: this.$('.project-selector'),
            excludeProjectIds: this.options.excludeProjectIds,
            isSingleChoice: this.options.isSingleChoice,
            onProjectSelected: _.bind(function (projects) {
                this.projects = projects;
            }, this),
            dataTableColumns: [
                {name: 'projectName', sort: 1},
                {name: 'city', sort: 0},
                {name: 'state', sort: 0},
                {name: 'bidsdue', sort: 0},
                {name: 'created', sort: 0}
            ],
            dataTableHeaderData: {
                isHideDeletedFilter: true
            }
        });
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.projects);
        }

        this.removeModal();
    },
    cancel: function () {
        this.removeModal();
    }
});

PJQ.views.projects.ProjectSelectorInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Projects-Select-Input'),
        subTemplates: {
            projectBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Projects-Select-Input-Projects')
        },
        isSingleChoice: false,
        onAdd: _.noop,
        onChange: _.noop,
        onDelete: _.noop,
        canEdit: false,
        selectedProjects: null,
        selectedProjectIds: null, // If you only have a list of ids, pass it in as selectedProjectIds,
        emptyNotice: 'No Projects Selected',
    },
    events: {
        "click .project-select-input-add": "edit",
        "click .project-select-input-delete": "deleteProject"
    },
    beforeFirstRender() {
        this.selectedProjects = this.options.selectedProjects ? this.options.selectedProjects : (this.options.isSingleChoice ? null : []);
        this.projects = this.options.projects;
        this.isFetched = false;

        if (!this.projects) {
            this.projects = new PJQ.collections.projects.Projects()
        }

        if (!this.projects.isFetched) {
            this.projects.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            })
        } else {
            this.isFetched = true;
        }
    },
    afterRender() {
        if (!this.isFetched)
            return;

        let formGroup = this.$el.closest('.form-group');
        let addButton = formGroup.find('label').find('.project-select-input-add');

        // If the button already exists, remove it
        if (_.size(addButton) > 0) {
            addButton.remove();
        }

        if (this.options.canEdit) {
            // Always create a new button and append it
            addButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm ml-1 project-select-input-add"><i class="fal fa-sm fa-pencil"></i></button>');
            formGroup.find('label').first().append(addButton);
            addButton.on('click', _.bind(this.edit, this));
        }

        if (this.options.selectedProjectIds) {
            if (this.options.isSingleChoice) {
                let projectId = PJQ.helpers.objectHelpers.refinedType(this.options.selectedProjectIds) !== 'array' ? this.options.selectedProjectIds : this.options.selectedProjectIds[0];
                this.selectedProjects = this.projects.get(projectId);
            } else {
                let selectedProjects = [];
                _.each(this.options.selectedProjectIds, function (id) {
                    let project = this.projects.get(id);
                    if (project) {
                        selectedProjects.push(project);
                    }
                }, this)
                this.selectedProjects = selectedProjects;
            }
        }

        this.renderSelectedProjects();
    },
    renderSelectedProjects: function () {
        let data = this.selectedProjects;
        if (this.selectedProjects && this.options.isSingleChoice)
            data = [this.selectedProjects];

        if (_.size(data) === 0) {
            this.$('.project-select-list').html('<div class="text-muted font-weight-light mt-1 fs-16">' + this.options.emptyNotice + '</div>');
        } else {
            this.renderSubTemplate(false, this.options.subTemplates.projectBadge, this.$('.project-select-list'), {
                models: data,
                isSingleChoice: this.options.isSingleChoice,
                canEdit: this.options.canEdit
            });
        }
    },
    edit: function () {
        let excludeProjectIds = [];
        if (this.options.isSingleChoice && this.selectedProjects) {
            excludeProjectIds.push(this.selectedProjects.id);
        } else {
            excludeProjectIds = _.map(this.selectedProjects, function (project) {
                return project.id;
            }, this)
        }
        this.selector = new PJQ.views.projects.ProjectSelectorModal({
            contacts: this.options.contacts,
            excludeProjectIds: excludeProjectIds,
            isSingleChoice: this.options.isSingleChoice,
            onSave: _.bind(function (newProjects) {
                this.selectedProjects = this.options.isSingleChoice ? newProjects : _.union(this.selectedProjects, newProjects);
                this.renderSelectedProjects();
                this.options.onAdd(newProjects, this.selectedProjects);
                this.options.onChange(this.selectedProjects);
            }, this)
        });
    },
    deleteProject: function (e) {
        let id = $(e.target).closest('.select-project-container').data('projectId');
        if (this.options.isSingleChoice) {
            this.options.onDelete(this.selectedProjects, null);
            this.options.onChange(null);
            this.selectedProjects = null;
        } else {
            let deletedProject = _.find(this.selectedProjects, function (project) {
                return project.id === id
            });
            if (deletedProject != null) {
                this.selectedProjects = _.filter(this.selectedProjects, function (project) {
                    return project.id !== id;
                });
                this.options.onDelete(deletedProject, this.selectedProjects);
                this.options.onChange(this.selectedProjects);
            }
        }
        this.renderSelectedProjects();
    },
})

PJQ.views.projects.ProjectSelectorDataTable = PJQ.views.dataTables.DataTable.extend({
    options: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Selector')
        }
    },
    events: {
        'keyup .datatable-search': 'search',
        'click .project-selector-clear-filters': 'clearFilters'
    },
    beforeDataTableRender: function () {
        this.projectStatusFilter = ["ready"];
        this.projectStatusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.project-selector-status-filter'),
            onChange: _.bind(function (value) {
                this.projectStatusFilter = value;
                this.filter(value);
            }, this),
            isMultiple: true,
            noneSelectedText: 'No Filters',
            defaultValue: this.projectStatusFilter
        });
    },
    getFilterData: function () {
        return _.filter(this.options.data, function (row) {
            return _.size(this.projectStatusFilter) === 0 || _.indexOf(this.projectStatusFilter, row.attributes.status.toLowerCase()) !== -1;
        }, this);
    },
    afterSearch: function () {
        this.$('.project-selector-clear-filters').prop('disabled', _.size(this.$('input.datatable-search').val()) === 0 && _.size(this.projectStatusFilter) === 0);
    },
    clearFilters: function () {
        this.projectStatusFilter = null;
        this.projectStatusFilterPicker.deselectAll();
        this.$('input.datatable-search').val('');
        this.search();
    }
});

PJQ.models.projects.ProjectAttachment = PJQ.models.files.File.extend({
    idAttribute: 'entryId'
});

PJQ.collections.projects.ProjectAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.projects.ProjectAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'attachments'
            }
        ], [
            {
                parameter: 'shared',
                value: this.options.isShared != null ? this.options.isShared : true
            },
            {
                parameter: 'priv',
                value: this.options.isPrivate != null ? this.options.isPrivate : true
            },
            {
                parameter: 'recursive',
                value: !this.options.isDeferred
            }
        ])
    }
});

PJQ.models.projects.ProjectNDA = PJQ.models.BaseModel.extend({
    idAttribute: 'ndaId',
    endpoint: function () {
        if (this.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.project.id
                },
                {
                    endpoint: 'nda'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'nda',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model) {
            if (model.project != null) {
                this.project = model.project;
            }
        }
        return model;
    }
});

PJQ.collections.projects.ProjectNDAs = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.projects.ProjectNDA,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'nda'
            }
        ])
    }
});

PJQ.views.projects.ProjectSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Project-Selector'),
        isDisableSelected: false,
        isSingleChoice: false,
        onProjectSelected: _.noop,
        excludeProjectIds: [],
        dataTableHeaderData: {
            isHideDeletedFilter: false
        },
        dataTableColumns: null
    },
    events: {
        "change .select-project": "selectProject"
    },
    beforeFirstRender: function () {

        if (this.options.dataTableColumns === null)
            this.options.dataTableColumns = [
                {name: 'projectName', sort: 1},
                {name: 'city', sort: 0},
                {name: 'state', sort: 0}
            ];

        if (!this.options.isSingleChoice) {
            this.selectedProjects = [];
        }

        this.collection = new PJQ.collections.projects.Projects();
        this.listenTo(this.collection, 'sync', this.render);
        this.collection.fetch();
    },
    afterRender: function () {
        let order = null;
        _.each(this.options.dataTableColumns, _.bind(function (column, index) {
            if (column.sort !== 0)
                order = [index + 1, column.sort === 1 ? 'asc' : 'desc'];
        }, this));

        this.dataTable = new PJQ.views.projects.ProjectSelectorDataTable({
            el: '.projects-data-table-container',
            data: _.filter(this.collection.models, _.bind(function (model) {
                return this.options.excludeProjectIds.indexOf(model.id) === -1
            }, this)),
            columns: this.getColumns(),
            order: order,
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Project-Selector')
            },
            headerData: this.options.dataTableHeaderData
        });
    },
    getColumns: function () {
        let columns = [
            {
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            }
        ];

        _.each(this.options.dataTableColumns, _.bind(function (column, index) {

            switch (column.name) {
                case 'projectId':
                    columns.push({
                        "data": "attributes.projectId",
                        "title": "Project Id"
                    });
                    break;
                case 'projectName':
                    columns.push({
                        "data": "attributes.projectName",
                        "title": "Project Name"
                    });
                    break;
                case 'address1':
                    columns.push({
                        "data": "attributes.address1",
                        "title": "Address 1"
                    });
                    break;
                case 'address2':
                    columns.push({
                        "data": "attributes.address2",
                        "title": "Address 2"
                    });
                    break;
                case 'city':
                    columns.push({
                        "data": "attributes.city",
                        "title": "City"
                    });
                    break;
                case 'state':
                    columns.push({
                        "data": "attributes.state",
                        "title": "State"
                    });
                    break;
                case 'zip':
                    columns.push({
                        "data": "attributes.zip",
                        "title": "Zip"
                    });
                    break;
                case 'created':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return new Date(row.attributes.created);
                            },
                            "filter": "attributes.created",
                            "display": function (row) {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.created), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                            }
                        },
                        "title": "Created"
                    });
                    break;
                case 'bidsdue':
                    let responseDueLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : "Response Due";
                    columns.push({
                        "data": {
                            "_": function (row) {

                                let dateTemp = new Date();
                                if (row.attributes.bidsDue == null)
                                    return dateTemp.addDays(-20000);
                                if (row.attributes.rDueText === 'ASAP')
                                    return dateTemp.addDays(-10000);

                                return new Date(row.attributes.bidsDue);
                            },
                            "filter": "attributes.bidsDue",
                            "display": function (row) {
                                if (row.attributes.bidsDue == null)
                                    return "N/A";
                                if (row.attributes.rDueText === 'ASAP')
                                    return row.attributes.rDueText;

                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.attributes.bidsDue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }
                        },
                        "title": responseDueLabel
                    });
                    break;
                case 'userDisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user && row.attributes.user.displayName) ? row.attributes.user.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : "Project Contact"
                    });
                    break;
                case 'user2DisplayName':
                    columns.push({
                        "data": {
                            "_": function (row) {
                                return (row.attributes.user2 && row.attributes.user2.displayName) ? row.attributes.user2.displayName : '';
                            }
                        },
                        "title": PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : "Project Contact 2"
                    });
                    break;
            }
        }, this));

        return columns;
    },
    selectProject: function (e) {
        let target = $(e.currentTarget),
            project = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-project').not(target).text('Select').prop('checked', false); //.removeClass('btn-primary').addClass('btn-secondary');
            if (project.get('isSelected')) {
                project.set('isSelected', false);
                this.selectedProject = null;
            } else {
                project.set('isSelected', true);
                this.selectedProject = project;
                this.collection.get(project.id);
                _.each(this.collection.models, _.bind(function (dtProject) {
                    if (project.id !== dtProject.id)
                        dtProject.set('isSelected', false);
                }, this));
            }
            this.options.onProjectSelected(this.selectedProject);
        } else {
            if (project.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                project.set('isSelected', false);
                this.selectedProjects = _.reject(this.selectedProjects, function (selProject) {
                    return selProject.id === project.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                project.set('isSelected', true);
                this.selectedProjects.push(project);
            }
            this.options.onProjectSelected(this.selectedProjects);
        }
    }
});

PJQ.views.projects.PublicProjects = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Public-Projects-Note')
    },
    events: {
        'click .project-header': 'projectClicked'
    },
    beforeFirstRender: function () {
        //this is an app route, make sure the session is fetched
        if (!PJQ.app.session.isFetched) {
            PJQ.app.session.fetch();
        }

        this.collection = new PJQ.collections.projects.Projects([], {
            isBidding: true
        });
        this.collection.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        })
    },
    renderData: function () {

        return {
            collection: this.collection,
            emptyMessage: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PUBLIC_PROJECTS_EMPTY_MESSAGE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PUBLIC_PROJECTS_EMPTY_MESSAGE) : "There currently aren't any public projects"
        };
    },
    projectClicked: function (e) {
        let cid = $(e.currentTarget).data('cid'),
            project = this.collection.get(cid);
        this.goToProject(project);
    },
    goToProject: function (project) {
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PUBLIC_PROJECTS_REQ_REG)) {
            let regTabId = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.REGISTRATION_TAB_ID);
            window.location.href = window.location.origin + '/Default.aspx?tabid=' + regTabId.toString() + '&subselfreg=1';
        } else {
            PJQ.helpers.projectHelpers.accessKeyNavigate(project.get('accessKey'), _.bind(function (err) {
                if (err != null) {
                    this.renderError(err);
                }
            }, this));
        }
    }
});

PJQ.views.projects.BlueBookPublishModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Blue-Book-Publish'),
        subTemplates: {
            dodgeTooltip: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'dodge-details-tooltip')
        },
        maxWidth: '800px',
        onAccept: null
    },
    events: {
        'click .btn-publish': 'publish'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    beforeRender: function () {
        if (this.model == null) {
            let user = PJQ.app.session.user;
            user.fetch({
                success: _.bind(function () {
                    this.model = new PJQ.models.projects.BlueBookProject({
                        project: this.options.project,
                        user: user
                    });
                    this.model.fetch({
                        success: _.bind(function () {
                            this.render();
                        }, this)
                    });
                }, this)
            });
        }
    },
    afterRender: function () {
        if (this.model == null) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.Tooltip(this.$('.dda-details'), {
            template: this.options.subTemplates.dodgeTooltip,
            container: this.$el,
            placement: 'right',
            trigger: 'click',
            renderData: _.bind(function () {
                return {};
            }, this)
        });

        let statePicker = new PJQ.inputs.StatePicker({
            el: this.$('.contact-state'),
            defaultValue: this.model.get('contactState') ? this.model.get('contactState').toUpperCase() : null,
            country: this.model.get('contactCountry') ? this.model.get('contactCountry').toUpperCase() : null,
            onChange: _.bind(function (value) {
                this.model.set('contactState', value);
            }, this)
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.contact-country'),
            defaultValue: this.model.get('contactCountry') ? this.model.get('contactCountry').toUpperCase() : null,
            statePicker: statePicker,
            zipInput: this.$('.contact-zip'),
            onChange: _.bind(function (value) {
                this.model.set('contactCountry', value);
            }, this)
        });

        let projectStatePicker = new PJQ.inputs.StatePicker({
            el: this.$('.project-state'),
            country: this.model.get('projectCountry') ? this.model.get('projectCountry').toUpperCase() : null,
            defaultValue: this.model.get('projectState') ? this.model.get('projectState').toUpperCase() : null,
            onChange: _.bind(function (value) {
                this.model.set('projectState', value);
            }, this)
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.project-country'),
            defaultValue: this.model.get('projectCountry') ? this.model.get('projectCountry').toUpperCase() : null,
            statePicker: projectStatePicker,
            zipInput: this.$('.project-zip'),
            onChange: _.bind(function (value) {
                this.model.set('projectCountry', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.project-role'),
            defaultValue: this.model.get('projectRole'),
            onChange: _.bind(function (value) {
                this.model.set('projectRole', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.project-type'),
            defaultValue: this.model.get('projectType'),
            onChange: _.bind(function (value) {
                this.model.set('projectType', value);
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.input-labor-status'),
            isMultiple: true,
            defaultValue: this.model.get('laborStatus'),
            onChange: _.bind(function (value) {
                this.model.set('laborStatus', value);
            }, this)
        });

        this.model.project.fetchGroups(_.bind(function (projectGroups) {
            this.model.set('groups', projectGroups.models);
            this.groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.group-selector'),
                selectedGroups: projectGroups,
                onGroupSelected: _.bind(function () {
                    this.model.set('groups', this.groupSelector.getGroupsData().selected);
                }, this)
            });
        }, this));

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-contact-phone'));

        new PJQ.inputs.Datepicker({
            el: this.$('.input-bids-due'),
            datepickerOptions: {
                defaultDate: this.model.get('bidsDue'),
            },
            onChange: _.bind(function (newTime) {
                this.model.set('bidsDue', newTime);
            }, this)
        });
    },
    publish: function () {
        let $err = this.$('.error-container');
        if (_.size(this.model.get('groups')) === 0) {
            this.groupSelector.showError('You must select at least 1 trade');
            $err.removeClass('hidden');
            return;
        }

        // let dodgeEnabled = $("input[type=radio][name=dodge]:checked").val();
        // if (dodgeEnabled == null) {
        //     this.$('.dodge-div').addClass('alert-danger');
        //     $err.removeClass('hidden');
        //     return;
        // }
        // this.model.set('includeDodge', dodgeEnabled.toLowerCase() === 'true' ? true : false);
        // this.$('.dodge-div').removeClass('alert-danger');
        $err.addClass('hidden');
        this.groupSelector.hideError();

        let loader = new PJQ.Loader(this.$('.btn-publish'), {
            loadingText: "Publishing..."
        });
        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
                PJQ.notifications.notify.successNotify({
                    message: 'Project Published to The Blue Book'
                });
            }, this),
            error: _.bind(function () {
                loader.remove();
                PJQ.notifications.notify.successNotify({
                    message: 'Failed to publish to the blue book.  Please try again in a few minutes'
                });
            }, this)
        });
    }
});

PJQ.models.projects.BlueBookProject = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.project.id
            },
            {
                endpoint: 'bluebook'
            }
        ]);
    },
    parse: function (model) {
        if (model) {
            if (model.user != null) {
                model.companyName = model.user.get('companyName');
                model.contactName = model.user.get('contactName');
                model.contactAddress = (_.size(model.user.get('address1')) > 0 ? model.user.get('address1') + " " : "") + (model.user.get('address2') != null ? model.user.get('address2') : "");
                model.contactCity = model.user.get('city');
                model.contactState = model.user.get('state');
                model.contactZip = model.user.get('zip');
                model.contactCountry = model.user.get('country');
                model.contactPhone = model.user.get('phone');
                model.contactEmail = model.user.get('email');
            }

            if (model.project != null) {
                this.project = model.project;
                model.projectRole = 'General Contractor - Bidding';
                model.projectName = model.project.get('projectName');
                model.projectAddress = (_.size(model.project.get('address1')) > 0 ? model.project.get('address1') + " " : "") + (model.project.get('address2') != null ? model.project.get('address2') : "");
                model.projectCity = model.project.get('city');
                model.projectState = model.project.get('state');
                model.projectZip = model.project.get('zip');
                model.projectCountry = model.project.get('country');
                model.bidsDue = model.project.get('bidsDue');
            }

            if (model.contactNameOverride !== null)
                model.contactName = model.contactNameOverride;

            if (model.emailOverride !== null)
                model.contactEmail = model.emailOverride;
        }
        return model;
    }
});

PJQ.views.projects.UploadParticipantBidDocumentsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Upload-Participant-Bid-Docs'),
        minWidth: '500px',
        onSave: _.noop,
        contact: null
    },
    events: {
        'click .save-attachments': 'onSave'
    },
    beforeRender: function () {
        this.renderData = {
            contact: this.options.contact
        };
    },
    afterRender: function () {
        this.uploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.uploader')
        });
    },
    onSave: function () {
        if (this.uploader.collection.length === 0)
            return;

        // construct endpoint and post folder accordingly
        let postData = {
            attachments: this.uploader.collection.toJSON()
        };

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'participants',
                value: this.options.contact.get('contactId')
            },
            {
                endpoint: 'bids'
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: postData,
            isApi2: true
        }).post().done(_.bind(function (response) {
            if (typeof this.options.onSave === 'function') {
                this.options.onSave(response);
            }

            PJQ.notifications.notify.successNotify({
                message: 'Bid documents uploaded successfully.'
            });
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Something went wrong!'
            });
        });

        this.removeModal();
    }
});
